module.exports = __webpack_public_path__ + "static/1-0bdb1aa7454a37f7b6947b2632cdc857.jpg";